import { quickview } from './_quickview';
import { flatSizeResize } from '../../modules/productDisplay/_swatchClick';
import { flatSizeClickMobile } from '../../modules/productDisplay/_flatSizeClickMobile';
import { qtyButtons } from '../global/_qtyButtons';
import Cookies from 'js-cookie';
import { getAllImages, altClickImages, buildMainSkuObj, getAttrDisplayStyle, getAttrLength, getAttrValues, dropDownAttrChange, buttonAttrChange, oneAttrPageLoad, dropDownOneAttrChange, buttonOneAttrChange, itemPageLoad, oneOptPageLoad } from '../modals_2017/_attrQVfunct';

const qvDesktop = (
	paramJSON,
	trackingJSON,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName,
	calCodeIds
) => {
	let qvHTML = `<div id="quickviewModalDesktop" class="dynamicModalContainer modal fade modal-quickview in qv-modal" tabindex="-1" role="dialog" aria-label="QuickView" aria-modal="true" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
                    <div class="modal-dialog" role="document">
						<input type="hidden" name="calCodeIds" value="${calCodeIds}">
						<div id="quickViewOverlay">
							<div id="innerOverlay"></div>
						</div>
                        <div class="modal-content">
                             <div class="modal-header">
                                <button data-twist="modal-close" type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                            </div>
                        <div data-twist="modal-body" class="modal-body">${altImgTString}
                            <div class="col-xs-12 col-sm-6 quickview-image">
                                <div class="row">
                                    <div class="zoomController not-zoomed">
                                                    <div data-twist="zoom-close" class="zoom-close" style="display: none;">×</div>
                                                    <div id="zoomContainer">
                                                        <img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
                                                    </div>
                                                    <div class="pinch-zoom-container">
                                                            <div class="mainProductImage qv-pinch-zoom">${mainImgTString}</div>
                                                    </div>
                                        </div>
                                    </div>
                                </div>
                        <section class="q-view-scroll">
						<style>
						.col-xs-12.col-sm-5.q-view-content.mCustomScrollbar::-webkit-scrollbar {scrollbar-width: none;-ms-overflow-style: none;display: none;}
						#mCSB_1_scrollbar_vertical {display:none !important;}
						</style>
                        <div class="col-xs-12 col-sm-5 q-view-content mCustomScrollbar">
                        <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
                        <h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
                        <div class="row">
							  ${pricingTString}
                              ${qvTString}
							 ${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON);
	$('body').addClass('modal-open');
	$('html').addClass('html-modal-open');
	$('.modal-content .close').trigger('focus');
	qtyButtons();
	$('#quickViewOverlay').remove();
};

const qvMobile = (
	paramJSON,
	trackingJSON,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewModalMobile" class="dynamicModalContainer modal fade modal-quickview in qv-modal" tabindex="-1" role="dialog" aria-label="QuickView" aria-modal="true" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
			<div class="modal-dialog">
				<div id="quickViewOverlay">
					<div id="innerOverlay"></div>
				</div>
				<div class="modal-content">
						<div class="modal-header qvCenterProductInfo">
								<button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
									<span aria-hidden="true">×</span>
									<span class="sr-only">Close</span>
								</button>
								<h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
								<h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
							${pricingTString}
						</div>
						<div data-twist="modal-body" class="modal-body">
								<div class="col-xs-12 col-sm-6 quickview-image">
										<div class="row">
												<div class="zoomController">
														<div data-twist="zoom-close" class="zoom-close">×</div>
														<div id="zoomContainer">
																<img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
														</div>
							<div id="containerPinchZoom">

							</div>
							<div class="initialImg" style="display:none;">
								${mainImgTString}
							</div>
												</div>
										</div>
								</div>
								${altImgTString}
								<section class="q-view-scroll">
										<div class="col-xs-12 col-sm-5 p-5 q-view-content">
												<div class="row">
												${qvTString}
														${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON, mainImgTString, mainImgTString);
	flatSizeResize();
	flatSizeClickMobile();
	if (!$('.dynamicModalContainer .size-select-group').children().hasClass('one-option')) {
		$('.dynamicModalContainer .size-select-group').addClass('select-hide');
	}
	$('.dynamicModalContainer .size-select-group select').addClass('select-hide');
	qtyButtons();
	$('#quickViewOverlay').remove();
};

const qvSuperMobile = (
	paramJSON,
	trackingJSON,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewModalMobile" class="dynamicModalContainer modal fade modal-quickview in qv-modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
			<div class="modal-dialog">
					<div class="modal-content">
							<div class="modal-header qvCenterProductInfo">
									<button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
										<span aria-hidden="true">×</span>
										<span class="sr-only">Close</span>
                                    </button>
                                    <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
									<h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
					          ${pricingTString}
							</div>
							<div data-twist="modal-body" class="modal-body">
									<div class="col-xs-12 col-sm-6 quickview-image">
											<div class="row">
													<div class="zoomController">
															<div data-twist="zoom-close" class="zoom-close">×</div>
															<div id="zoomContainer">
																	<img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
															</div>
                              <div id="containerPinchZoom">

                              </div>
                              <div class="initialImg" style="display:none;">
                                  ${mainImgTString}
                              </div>
													</div>
											</div>
                                    </div>
                                    ${altImgTString}
									<section class="q-view-scroll">
											<div class="col-xs-12 col-sm-6 p-5 q-view-content">
													<div class="row">
                                                    ${qvTString}
                                                    ${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON, mainImgTString);
	flatSizeResize();
	flatSizeClickMobile();
	if (!$('.dynamicModalContainer .size-select-group').children().hasClass('one-option')) {
		$('.dynamicModalContainer .size-select-group').addClass('select-hide');
	}
	$('.dynamicModalContainer .size-select-group select').addClass('select-hide');
	qtyButtons();
};

const qvTablet = (
	paramJSON,
	trackingJSON,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewModalDesktop" class="dynamicModalContainer modal fade modal-quickview in qv-modal" tabindex="-1" role="dialog" aria-label="QuickView" aria-modal="true" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
              <div class="modal-dialog">
				<div id="quickViewOverlay">
					<div id="innerOverlay"></div>
				</div>
                <div class="modal-content">
                  <div class="modal-header">
                    <button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
					            <span aria-hidden="true">×</span>
					            <span class="sr-only">Close</span>
				            </button>
                  </div>
                  <div data-twist="modal-body" class="modal-body">
                        ${altImgTString}
                <div class="col-xs-12 col-sm-6 quickview-image">
                    <div class="row">
                        <div class="zoomController not-zoomed">
                            <div data-twist="zoom-close" class="zoom-close" style="display: none;">×</div>
                            <div id="zoomContainer">
                                <img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
                            </div>
                            <div id="containerPinchZoom">

                            </div>
                            <div class="initialImg" style="display:none;">
                                ${mainImgTString}
                            </div>
                        </div>
                    </div>
                </div>
                <section class="q-view-scroll">
                    <div class="col-xs-12 col-sm-5 p-5 q-view-content">
                    <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
					<h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
                        <div class="row">
							${pricingTString}
                            ${qvTString}
				            ${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON, mainImgTString);
	$('.modal-content .close').focus();
	qtyButtons();
	$('#quickViewOverlay').remove();
};

const cylDesktop = (
	paramJSON,
	trackingJSON,
	accessoryList,
	accessoryListTitleText,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewOssModalDesktop" class="dynamicModalContainer modal fade modal-quickview in oss-modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
					            <span aria-hidden="true">×</span>
					            <span class="sr-only">Close</span>
				            </button>
                  </div>
									<div id="accessoryList"><h2 class="ossH2">${accessoryListTitleText}</h2>
						      ${accessoryList}
                  <div data-twist="modal-body" class="modal-body">
                        ${altImgTString}
                <div class="col-xs-12 col-sm-5 quickview-image">
                    <div class="row">
                        <div class="zoomController not-zoomed">
                            <div data-twist="zoom-close" class="zoom-close" style="display: none;">×</div>
                            <div id="zoomContainer">
                                <img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
                            </div>
                            <div class="pinch-zoom-container">
								<div class="mainProductImage qv-pinch-zoom">
										${mainImgTString}
								</div>
						</div>
                        </div>
                    </div>
                </div>
                <section class="q-view-scroll">
                    <div class="col-xs-12 col-sm-4 p-5 q-view-content">
                    <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
					<h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
                        <div class="row">
							${pricingTString}
                            ${qvTString}
							${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON);
	$('body').addClass('modal-open');
	$('html').addClass('html-modal-open');

	// $('#ModalLabel').focus();
	$('.modal-content .close').focus();
};

const cylMobile = (
	paramJSON,
	trackingJSON,
	accessoryList,
	accessoryListTitleText,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewOssModalMobile" class="dynamicModalContainer modal fade modal-quickview in oss-modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
		<div class="modal-dialog">
				<div class="modal-content">
				    <button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
					    <span aria-hidden="true">×</span>
					    <span class="sr-only">Close</span>
				    </button>
						<h2 class="ossH2">${accessoryListTitleText}</h2><div id="accessoryList">
						${accessoryList}
                        <div class="modal-header">
                        <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
						<h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
									${pricingTString}
						</div>
						<div data-twist="modal-body" class="modal-body">
								<div class="col-xs-12 col-sm-5 quickview-image">
										<div class="row">
												<div class="zoomController">
														<div data-twist="zoom-close" class="zoom-close">×</div>
														<div id="zoomContainer">
																<img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
														</div>
                            <div id="containerPinchZoom">

                            </div>
                            <div class="initialImg" style="display:none;">
                                ${mainImgTString}
                            </div>
												</div>
										</div>
								</div>
								${altImgTString}
								<section class="q-view-scroll">
										<div class="col-xs-12 col-sm-4 p-5 q-view-content">
												<div class="row">
												    ${qvTString}
														${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON, mainImgTString);
	flatSizeResize();
	flatSizeClickMobile();

	if (!$('.dynamicModalContainer .size-select-group').children().hasClass('one-option')) {
		$('.dynamicModalContainer .size-select-group').addClass('select-hide');
	}
	$('.dynamicModalContainer .size-select-group select').addClass('select-hide');
};

const cylSuperMobile = (
	paramJSON,
	trackingJSON,
	accessoryList,
	accessoryListTitleText,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewOssModalSuperMobile" class="dynamicModalContainer modal fade modal-quickview in oss-modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
		<div class="modal-dialog">
				<div class="modal-content">
				    <button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
					    <span aria-hidden="true">×</span>
					    <span class="sr-only">Close</span>
				    </button>
						<h2 class="ossH2">${accessoryListTitleText}</h2><div id="accessoryList">
						${accessoryList}
                        <div class="modal-header">
                        <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
						<h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
									${pricingTString}
						</div>
						<div data-twist="modal-body" class="modal-body">
								<div class="col-xs-12 col-sm-5 quickview-image">
										<div class="row">
												<div class="zoomController">
														<div data-twist="zoom-close" class="zoom-close">×</div>
														<div id="zoomContainer">
																<img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
														</div>
                            <div id="containerPinchZoom">

                            </div>
                            <div class="initialImg" style="display:none;">
                                ${mainImgTString}
                            </div>
												</div>
										</div>
								</div>
								<section class="q-view-scroll">
										<div class="col-xs-12 col-sm-7 p-5 q-view-content">
												<div class="row">
												    ${qvTString}
														${altImgTString}
														${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON, mainImgTString);
	flatSizeResize();
	flatSizeClickMobile();
	if (!$('.dynamicModalContainer .size-select-group').children().hasClass('one-option')) {
		$('.dynamicModalContainer .size-select-group').addClass('select-hide');
	}
	$('.dynamicModalContainer .size-select-group select').addClass('select-hide');
};

const cylTablet = (
	paramJSON,
	trackingJSON,
	accessoryList,
	accessoryListTitleText,
	altImgTString,
	mainImgTString,
	modalTitle,
	pricingTString,
	productID,
	productURL,
	qvTString,
	qvTString_end,
	personalizationBrand,
	urlFormattedBrandName
) => {
	let qvHTML = `<div id="quickviewOssModalDesktop" class="dynamicModalContainer modal fade modal-quickview in oss-modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
						<div class="modal-dialog">
							<div class="modal-content">
							  <button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
								  <span aria-hidden="true">×</span>
								  <span class="sr-only">Close</span>
							  </button>
								<h2 class="ossH2">${accessoryListTitleText}</h2><div id="accessoryList">
							  ${accessoryList}
								<div class="modal-header">
								</div>
								<div data-twist="modal-body" class="modal-body">
								${altImgTString}
							<div class="col-xs-12 col-sm-5 quickview-image">
									<div class="row">
											<div class="zoomController not-zoomed">
													<div data-twist="zoom-close" class="zoom-close" style="display: none;">×</div>
													<div id="zoomContainer">
															<img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
													</div>
                          <div id="containerPinchZoom">

                          </div>
                          <div class="initialImg" style="display:none;">
                              ${mainImgTString}
                          </div>
											</div>
									</div>
							</div>
							<section class="q-view-scroll">
									<div class="col-xs-12 col-sm-4 p-5 q-view-content">
                                    <h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
                                    <h4 data-twist="modal-title" class="modal-title hide show" id="ModalLabel" tabindex="0"><a href="${productURL}">${modalTitle}</a></h4>
											<div class="row">
														${pricingTString}
											      ${qvTString}
														${qvTString_end}`;
	quickview(qvHTML, paramJSON, trackingJSON, mainImgTString);
};

const qv_notAvailable = (parsedJSON, trackingJSON, altImgTString, mainImgTString, modalTitle, urlFormattedBrandName, personalizationBrand) => {
	var errorMessage = '';
	if (parsedJSON.unavailableMessage !== undefined) errorMessage = freshenUp(parsedJSON.unavailableMessage);
	else if (parsedJSON.errorMessage !== undefined) errorMessage = freshenUp(parsedJSON.errorMessage);
	let qvHTML = `<div id="qv_notAvailable" class="dynamicModalContainer modal fade modal-quickview in qv-modal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel" aria-hidden="false" style="display: block;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button data-twist="modal-close" type="button" class="close" data-dismiss="modal">
                      <span aria-hidden="true">×</span>
                      <span class="sr-only">Close</span>
                    </button>
                </div>
                <div data-twist="modal-body" class="modal-body">
                    ${altImgTString}
                    <div class="col-xs-12 col-sm-6 quickview-image">
                        <div class="row">
                            <div class="zoomController not-zoomed">
                                <div data-twist="zoom-close" class="zoom-close" style="display: none;">×</div>
                                <div id="zoomContainer">
                                    <img data-twist="zoom-image" id="zoomImage" src="" alt="Full size zoom image">
                                </div>
                                <div class="pinch-zoom-container">
                                    <div class="mainProductImage qv-pinch-zoom">
                                        ${mainImgTString}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section class="q-view-scroll">
                        <div class="col-xs-12 col-sm-5 p-5 q-view-content">
							<h4 data-monaddedbrand data-twist="modal-title" class="modal-title hide show"><a href="/brand/${urlFormattedBrandName}"><strong>${personalizationBrand}</strong></a></h4>
							<h4 data-twist="modal-title" class="modal-title hide show m-t-5" id="ModalLabel" tabindex="0">${modalTitle}</h4>
                            <a data-twist="shop-all-brand-alt" class="btn btn-secondary m-t-10" id="shop-all-brand-alt" href="/brand/${urlFormattedBrandName}"  >Shop All ${personalizationBrand} <i class="fa fa-angle-right m-l-5"></i></a>
                            <div class="row">
                                <div class="alert alert-danger">${errorMessage}</div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in"></div>`;
	$('body').append(qvHTML);
	if ($('.tabletPage').length > 0) {
		var modalheight = window.innerHeight;
		$('#qv_notAvailable').css('height', modalheight);
		$('body').addClass('modal-special');
	}
	$('[data-dismiss="modal"]').on('click', function () {
		$('.modal-backdrop').remove();
		if ($('#qv_notAvailable').length > 0 && !$('.desktopPage').length > 0) {
			$('body').css('top', '');
		}
		$('.dynamicModalContainer').remove();
		if ($('body').hasClass('modal-open')) $('body').removeClass('modal-open');
		if ($('html').hasClass('html-modal-open')) $('html').removeClass('html-modal-open');
		if ($('body').hasClass('modal-special')) $('body').removeClass('modal-special');
	});
	$('.modal-content .close').focus();
	
};

const freshenUp = (string) => {
	return string !== undefined ? string.replace(/#double;/g, '"').replace(/#back;/g, '\\') : string;
};

const buildQV = (paramJSON, modalTitle) => {
	let zonosIsWorking = false;

	if (typeof zonos === 'object') {
		zonosIsWorking = true;
	} 

	const formatOnlyNumbers = (value) => {
		if (!zonosIsWorking && value !== undefined) {
			return value;
		}
		return value !== undefined ? Number(value.replace(/[^0-9\.]+/g,"")) : string;	};

	$('#OrderItemAdd_qv').remove();
	$.ajax({
		url: '/webapp/wcs/stores/servlet/QuickView',
		cache: true,
		type: 'GET',
		dataType: 'json',
		data: 'storeId=301&langId=-1&catalogId=301&productId=' + paramJSON.catentryId,
		beforeSend: function () {
			window.quickViewCategory = paramJSON.categoryId;
		},
		success: function (json) {
			let parsedJSON = json,
				isRegistry = $('#layoutRegistry').length > 0,
				notRegistry = !$('#layoutRegistry').length > 0,
				notWishlist = !$('.wish-list-page').length > 0;
			if (parsedJSON.pricing !== undefined) {
				try {
					if (parsedJSON.itemInfo) {
						dataLayer.itemInfo = parsedJSON.itemInfo;
					}
				} catch (e) { }
				var altImgTString = '',
					catEntryId = parsedJSON.pricing.catentryId,
					dept = parsedJSON.pricing.dept,
					mainImgName = '',
					mainImgTString = '',
					mic = parsedJSON.pricing.mic,
					style = parsedJSON.pricing.style,
					productID = parsedJSON.partnumber,
					productURL = parsedJSON.productURL,
					qvTString = '',
					limitedAvailability = parsedJSON.limitedAvailability !== undefined ? 'Y' : 'N',
					shipInternational = parsedJSON.isInternational,
					onSaleItemMap = '',
					onSpecial = '',
					onSpecialForm = '',
					onSpecialOption = '',
					superCat = parsedJSON.superCat;

				let price = parsedJSON.pricing.offerPriceRange;
				let origPrice = parsedJSON.pricing.listPriceRange;
				let wasPrice = parsedJSON.pricing.wasPriceRange;
				//for hiding skus in a <div> on pageload
				const allSkus = JSON.stringify(parsedJSON.skus);
				//format skus object
				const mainSkuObj = buildMainSkuObj(parsedJSON.skus);
				//are the attributes dropdown or flat				
				const attrDisplayStyle = getAttrDisplayStyle(mainSkuObj);
				//what are the values
				const attrValues = getAttrValues(parsedJSON);
				
				//Check for one Attr
				let attrLength = getAttrLength(parsedJSON.skus);				
			
				if (origPrice !== undefined && origPrice.indexOf('-') > -1) {
					origPrice = `<span class="price-number" data-range1="${parsedJSON.pricing.listPriceMin}">` + formatOnlyNumbers(origPrice.split('-')[0]) + `</span>-<span class="price-number no-right-margin" data-range2="${parsedJSON.pricing.listPriceMax}">` + formatOnlyNumbers(origPrice.split('-')[1]) + `</span>`;
				} else if (origPrice !== undefined) {
					origPrice = formatOnlyNumbers(origPrice);
				}

				if (wasPrice !== undefined && wasPrice.indexOf('-') > -1) {
					wasPrice = `<span class="price-number">` + formatOnlyNumbers(wasPrice.split('-')[0]) + `</span>-<span class="price-number no-right-margin">` + formatOnlyNumbers(wasPrice.split('-')[1]) + `</span>`;
				} else if (wasPrice !== undefined) {
					wasPrice = formatOnlyNumbers(wasPrice);
				}

				if (price !== undefined && price.indexOf('-') > -1) {
					price = `<span class="price-number">` + formatOnlyNumbers(price.split('-')[0]) + `</span>-<span class="price-number no-right-margin">` + formatOnlyNumbers(price.split('-')[1]) + `</span>`;
				} else if (price !== undefined) {
					price = formatOnlyNumbers(price);
				}

				// Split Brand from Modal Title
				var newTitle = '';
				try {
					newTitle = json.personalization.trackingJSON.product.name;
					if (newTitle != '') modalTitle = newTitle.split('#double;').join('"');
				} catch (e) { }
				let personalizationBrand = parsedJSON.personalization.brandName,
					urlFormattedBrandName = parsedJSON.personalization.urlFormattedBrandName,
					thisBrand1 = `${personalizationBrand} `,
					thisBrand2 = `${personalizationBrand}®`,
					splitText = modalTitle.toLowerCase().split('&').join('&'),
					brandWithSpace = splitText.indexOf(thisBrand1.toLowerCase()) == 0,
					brandWithR = splitText.indexOf(thisBrand2.toLowerCase()) == 0,
					brandPartOfName = brandWithSpace || brandWithR;
				if (brandPartOfName) {
					let realBrand = brandWithSpace ? thisBrand1 : thisBrand2,
						subStringIndex = realBrand.split('&').join('&').length;
					personalizationBrand = modalTitle.substring(0, subStringIndex);
					modalTitle = modalTitle.substring(subStringIndex);
				}
				// Build the pricing information
				var pricingTString = `<div class="quick-view-main-price">`;
				if (typeof zonos == 'object') {
					zonos.displayCurrency()
				}
				if (parsedJSON.pricing.onSpecial !== undefined) {
					onSpecial = parsedJSON.pricing.onSpecial;
					onSpecialForm = `data-formonspecial="${onSpecial}"`;
					onSpecialOption = `data-onspecial="${onSpecial}"`;
					var pricingTString_sub = `<div class="price-wrapper static" data-saledept="${dept}" data-salemic="${mic}" data-salestyle="${style}" data-onspecial="${onSpecial}" data-catentry="${catEntryId}">`;
					pricingTString_sub += `<span data-twist="reduced-copy" class="reduced-copy">${parsedJSON.pricing.onSpecialMessage}</span>`;
					if (origPrice !== undefined && typeof origPrice === 'string') {
						pricingTString_sub += `<span data-twist="original-price" class="price original-price">Orig.${origPrice}</span>`;
					} else if (origPrice !== undefined) {
						pricingTString_sub += `<span data-twist="original-price" class="price original-price">Orig. <span class="price-number">${origPrice}</span></span>`;
					}
					if (wasPrice !== undefined && typeof wasPrice === 'string') {
						pricingTString_sub += `<span data-twist="was-price" class="price was-price">Was ${wasPrice}</span></div>`;
					} else if (wasPrice !== undefined) {
						pricingTString_sub += `<span data-twist="was-price" class="price was-price">Was <span class="price-number">${wasPrice}</span></span>`;
					}
					if (price !== undefined && typeof price === 'string') {
						pricingTString_sub += `<span data-twist="now-price" class="price now-price">Now${price}</span></div>`;
					} else if (price !== undefined) {
						pricingTString_sub += `<span data-twist="now-price" class="price now-price">Now<span class="price-number no-right-margin">${price}</span></span></div>`;
					}
				} else
					if (price !== undefined && typeof price === 'string') {
						var pricingTString_sub = `<span data-regdept="${dept}" data-regmic="${mic}" data-regstyle="${style}" data-twist="item-price" id="itemPrice_${catEntryId}" class="price" data-catentry="${catEntryId}">${price}</span>`;
					} else {
						var pricingTString_sub = `<span data-regdept="${dept}" data-regmic="${mic}" data-regstyle="${style}" data-twist="item-price" id="itemPrice_${catEntryId}" class="price" data-catentry="${catEntryId}"><span class="price-number">${price}</span></span>`;
					}
				pricingTString += pricingTString_sub;
				if (parsedJSON.preview) {
					if (parsedJSON.previewEndDate > parsedJSON.currentDate) {
						pricingTString += `<span data-twist="pre-order-one" class="extended">Coming Soon</span>`;
					}
				}

				// show free shipping message
				var isSaleTrue = $('#isSaleDay').text() == 'true' && $('#isPreviewDay').text() == 'false',
					isCountryUS = Cookies.get('zCountry') == 'US';
				if ($('.desktopPage').length > 0 && !isSaleTrue && isCountryUS && parsedJSON.dil_calcodeIds == 'false') {
					var freeShippingThreshold = parseInt(parsedJSON.freeShippingThreshold),
						offerPriceMin = parseFloat(parsedJSON.pricing.offerPriceMin.split('$').join('')),
						offerPriceMax = parseFloat(parsedJSON.pricing.offerPriceMax.split('$').join(''));
					if (offerPriceMin >= freeShippingThreshold && offerPriceMax >= freeShippingThreshold) {
						pricingTString += `<span id="freeShippingMsg" class="hide-when-international"><svg role="img" aria-labelledby="freeShippingIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.15 33.54"><title id="freeShippingIcon">shipping</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M45.55,10H39.21V3.61A3.61,3.61,0,0,0,35.61,0h-32A3.61,3.61,0,0,0,0,3.61V24.73a3.61,3.61,0,0,0,3.61,3.61h.46a5.32,5.32,0,0,1,10.63,0h17a5.32,5.32,0,0,1,10.63,0h3.19a3.61,3.61,0,0,0,3.61-3.61V13.6A3.61,3.61,0,0,0,45.55,10Zm1.54,8.41H40v-6H44.9a2.19,2.19,0,0,1,2.19,2.19Z" /><path d="M14.06,28.26a4.74,4.74,0,1,0-4.18,5.25A4.74,4.74,0,0,0,14.06,28.26ZM9.35,31.48A2.69,2.69,0,1,1,12,28.8,2.69,2.69,0,0,1,9.35,31.48Z" /><path d="M41.75,28.26a4.74,4.74,0,1,0-4.18,5.25A4.74,4.74,0,0,0,41.75,28.26ZM37,31.48a2.69,2.69,0,1,1,2.69-2.69A2.69,2.69,0,0,1,37,31.48Z" /></g></g></svg>SHIPS FREE <span class="freeShippingSpan">- Exclusions Apply</span></span>`;
					}
					if (offerPriceMin != offerPriceMax && offerPriceMin < freeShippingThreshold && offerPriceMax >= freeShippingThreshold) {
						pricingTString += `<span id="freeShippingMsg" class="saveOnSelect hide-when-international"><svg role="img" aria-labelledby="freeShippingIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.15 33.54"><title id="freeShippingIcon">shipping</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M45.55,10H39.21V3.61A3.61,3.61,0,0,0,35.61,0h-32A3.61,3.61,0,0,0,0,3.61V24.73a3.61,3.61,0,0,0,3.61,3.61h.46a5.32,5.32,0,0,1,10.63,0h17a5.32,5.32,0,0,1,10.63,0h3.19a3.61,3.61,0,0,0,3.61-3.61V13.6A3.61,3.61,0,0,0,45.55,10Zm1.54,8.41H40v-6H44.9a2.19,2.19,0,0,1,2.19,2.19Z" /><path d="M14.06,28.26a4.74,4.74,0,1,0-4.18,5.25A4.74,4.74,0,0,0,14.06,28.26ZM9.35,31.48A2.69,2.69,0,1,1,12,28.8,2.69,2.69,0,0,1,9.35,31.48Z" /><path d="M41.75,28.26a4.74,4.74,0,1,0-4.18,5.25A4.74,4.74,0,0,0,41.75,28.26ZM37,31.48a2.69,2.69,0,1,1,2.69-2.69A2.69,2.69,0,0,1,37,31.48Z" /></g></g></svg>SHIPS FREE <span class="freeShippingSpan">- Exclusions Apply</span></span>`;
					}
				}
				pricingTString += `</div>`;

				// Build the Main Image
				if (parsedJSON.fullImage !== undefined) {
					mainImgName = freshenUp(parsedJSON.fullImage.imageName);
					mainImgTString = `<img data-twist="main-image" id='mainImg' class="mainImage" src="${mainImgName}" alt="${freshenUp(
						parsedJSON.fullImage.altText
					)}" style="visibility: visible;">`;
				}
				// Build the Sale Map
				if (parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId] !== undefined)
					onSaleItemMap += `<div class="hidden onSaleItemMap" data-productid="${parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].productId
						}" data-saledept="${parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].saleDept}" data-salemic="${parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].saleMic
						}">${freshenUp(parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].onSaleItemMap)}</div><div class="hidden markdownItemMap" data-productid="${parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].productId
						}" data-saledept="${parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].saleDept}" data-salemic="${parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].saleMic
						}">${freshenUp(parsedJSON['onSaleInfo_' + parsedJSON.pricing.catentryId].markdownItemMap)}</div>`;

				// Build the alternate images
				if (parsedJSON.altImages !== undefined) {					
					let sortedAlts = [],
						mainImages = {},
						alts = parsedJSON.altImages,
						colorsInOrder = [],
						altsObj = {};

					if (attrValues.Color) {
						// Create an array of all colors in their proper order
						attrValues.Color.values.map(color => colorsInOrder.push(color.value));

						// Build an object with colors as keys and their corresopnding main image name as values
						// Also adds missing main color images to alts array
						parsedJSON.skus.map((sku) => { 
							sku.definingAttributes.map((attr) => {
								if (attr.name == 'Color' && !mainImages[attr.value.value]) {
									mainImages[attr.value.value] = sku.fullImage;
									if (sku.fullImage != parsedJSON.fullImage.imageNameNoPath) {
										alts.push({'altText': `Color: ${sku.fullImage}`, 'imageName': sku.fullImage});
									}
								}						
							});
						});

						// Populating alts object used to build sortedAlts array
						colorsInOrder.map(color => {
							let imgs = alts.filter(alt => alt.imageName.includes(mainImages[color]));
							imgs.sort((a, b) => a.imageName.localeCompare(b.imageName));
							altsObj[color] = imgs;
						});

						// Building sortedAlts array
						colorsInOrder.map(color => {
							altsObj[color].map(img => sortedAlts.push(img));
						});
					} else {
						sortedAlts = alts.sort((a, b) => a.imageName.localeCompare(b.imageName));
					}

					altImgTString = `<div class="col-xs-12 col-sm-1"><div class="row">${onSaleItemMap}`;
					var altImgTString_sub = '';
					for (var i = 0; i < 4; i++) {
						if (sortedAlts[i] !== undefined && sortedAlts[i].imageName !== undefined) {
							let altImgName = sortedAlts[i].imageName,
								productNameForURL = productURL.split('/')[2];
							altImgTString_sub += `<li><img data-twist="alt-image-${i}" class="alt-image-tile" data-imgname='${altImgName}' alt="${freshenUp(
								sortedAlts[i].altText
							)}" data-fullimage="${altImgName}" src="//dimg.dillards.com/is/image/DillardsZoom/alt/${productNameForURL}/${altImgName}.jpg"></li>`;
						}
					}
					var altImgsLeft = sortedAlts.length - 4,
						moreAltImgs = '';
					if (altImgsLeft > 0 && notRegistry)
						moreAltImgs = `<a data-twist="quick-view-more" href="${productURL}" class="quick-view-more">+${altImgsLeft} More Image(s)</a>`;
					altImgTString += `<div class="alt-image-list-container" data-supercat="${superCat}"><ul>${altImgTString_sub}</ul>${moreAltImgs}</div></div></div>`;
				}

				// Build the description panel
				if (parsedJSON.longDescription !== undefined && isRegistry) {
				qvTString += `<div class="quick-view-description">
				<div class="panel-group" id="productpage-accordion">
					<h4>Description</h4>
					<div id="quickview-desc">
					<div data-twist="description-panel" class="panel-body desktop-description">`;
						if (parsedJSON.preOrder !== undefined && parsedJSON.preOrderText !== undefined) {
							qvTString += `<div data-twist="pre-order-alret" id="preorder-alert" class="alert alert-warning" role="alert">${parsedJSON.preOrderText}</div>`;
						}
						qvTString += `<p class="qv-item-num">Item# ${productID}</p>`;
						if (parsedJSON.auxVerbiage1 !== undefined) qvTString += freshenUp(parsedJSON.auxVerbiage1);
						if (parsedJSON.auxDescription1 !== undefined) qvTString += freshenUp(parsedJSON.auxDescription1);
						if (parsedJSON.preOrder) {
							qvTString += `<span data-twist="pre-order-two" class="extended">Pre-Order</span>`;
						}
						if (parsedJSON.preOrder !== undefined && parsedJSON.preOrder.previewEndDateMessage !== undefined)
							qvTString += '<span class="extended">' + freshenUp(parsedJSON.preOrder.previewEndDateMessage) + '</span>';
						if (parsedJSON.auxDescription2 !== undefined || parsedJSON.auxVerbiage2 !== undefined) {
							qvTString += `<div data-twist="desc-aux-1" id="desc-aux-1" class="desc-aux">`;
							if (parsedJSON.auxDescription2 !== undefined) qvTString += freshenUp(parsedJSON.auxDescription2);
							if (parsedJSON.auxVerbiage2 !== undefined) qvTString += freshenUp(parsedJSON.auxVerbiage2);
							qvTString += `</div>`;
						}
						qvTString += `${freshenUp(parsedJSON.longDescription)}`;

						if (parsedJSON.promotionCopy !== undefined) {
							qvTString += `<div data-twist="promotion-copy" id="promotionCopy" class="desc-aux">${freshenUp(parsedJSON.promotionCopy)}</div>`;
							qvTString += `<span class="dept-mic-style">D/M/S: ${dept} ${mic} ${parsedJSON.style}</span>`;
						}
						qvTString += `</div></div></div></div>`;
				}

				// Several files are looking for this element. Leaving it on the page, but hidden
				if (notRegistry) {
					qvTString += `<p class="qv-item-num hidden">Item# ${productID}</p>`;
				}
				if (notRegistry)
					qvTString += `<div class="qv-panel"><a data-twist="visit-product-page" href="${productURL}" class="quick-view-more">See Full Details</a></div>`;

				qvTString += `</div>`;

				if (notRegistry) {
					qvTString += `<div class="col-xs-12 product-select-boxes qv-intDiv">
					${onSaleItemMap}<form id="OrderItemAdd_qv" data-catentry="${catEntryId}" ${onSpecialForm} data-formdept="${dept}" data-formmic="${mic}">
					<input type="hidden" name="storeId" value="301">
					<input type="hidden" name="orderId" value=".">
					<input type="hidden" name="catalogId" value="301">
					<input type="hidden" name="langId" value="-1">
					<input type="hidden" name="errorViewName" value="ProductDisplayView">
					<input type="hidden" name="URL" value="ProductDisplayView">
					<input type="hidden" name="rURL" value="ProductDisplayView">
					<input type="hidden" name="catEntryId" id='catEntryIdSKU' value="">
					<input type='hidden' name='field2' value='${parsedJSON?.personalization?.superCatId}' id='FieldTwoForForm' />
					<input type="hidden" name="productId" value="${catEntryId}">
					<input type="hidden" name="fromCartRecs" value="true">
					<input type="hidden" name="shipInternational" id="shipInternationalQV" value="${shipInternational}">
					<input type="hidden" name="limitedAvailability" class="limitedAvailability" value="${limitedAvailability}">
					<input type="hidden" name="description" class="productDesc" value="${productID}|${catEntryId}|PP-PIP">`;
					qvTString += `<div class="hidden" id="allSkus">${allSkus}</div>`;
					if (paramJSON.orderItemIdEdit) {
						qvTString += `<input type="hidden" name="orderItemIdEdit" value="${paramJSON.orderItemIdEdit}">`;
					}
					
					// Build the attributes - start with what display style (dropdown, flat, etc..)
					Object.values(attrDisplayStyle).map((attr => {
						let attrName =  attr.attrName;
						let attrDisplayStyle =  attr.attrDisplayStyle;
						attrDisplayStyle = attrDisplayStyle.toLowerCase();
						//desktop and tablet always show dropdowns, if display style is empty, default to dropdown - on mobile, displayStyle is always determined by the sku data
						if($('.desktopPage').length > 0 || $('.tabletPage').length > 0) {
							attrDisplayStyle = 'dropdown';
						} else {
							if (attrDisplayStyle === '') {
								attrDisplayStyle = 'dropdown';
							} else {
								attrDisplayStyle = attrDisplayStyle;
							}
						}
						let selectName = attrName;
						let selectName_lc = selectName.toLowerCase().replace(' ', '');
						let selectForId = selectName.replace(' ', '-');
						let isSelectedOneOpt='';
						let optionLength='';
						let optionValue='';
						if (attrDisplayStyle == 'dropdown') {
							qvTString += `<div class="form-group form-attr ${selectName_lc}-select-group required">`;
							qvTString += `<label for="${selectName_lc}Input_id0">${selectName}</label>`;
							if (selectName_lc === 'size') {
								if ($('.desktopPage').length > 0 && parsedJSON.sizeChartName != undefined && parsedJSON.sizeChartName != '') {
									qvTString += `<button type="button" data-toggle="modal" data-novalidation data-target=".modal-size-chart" data-modal-title="Size Chart" data-modal-body='callSizeChart("${parsedJSON.sizeChartName}")' class="qv-size-chart-link" data-twist="size-chart"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.48 26.78" width="14"><title>size chart</title><g data-name="Layer 2"><g data-name="Layer 1"><path d="M0,0V26.78H53.48V0ZM51.48,24.78H2V2h9.14v8.07h2V2h12.6V15.12h2V2H40.33v8.07h2V2h9.15Z" /></g></g></svg>Size Chart<span class="sr-only">Opens a Size Chart Dialog</span></button>`;
								}
							}
							Object.values(attrValues).map((optVal => {
								if(optVal.name == attrName) {
									optionLength = optVal.values.length;
									optionValue = optVal.values[0].value;
								}
							}))
							if(optionLength > 1) {
								qvTString += `<select onchange='try{zonos.displayCurrency();}catch(e){console.log(e)}' onclick='try{zonos.displayCurrency();}catch(e){console.log(e)}' data-twist='${selectName_lc}-select-0' id='${selectForId}Input__id0' title='Please select valid ${selectName_lc}' 
								data-validate="required" data-attrlength=${attrLength} class='form-control ${selectName_lc}-select qvAttr' name="attrValue" data-orig='${selectName}' data-attrname='${selectName}'>`;
								qvTString += `<option value data-attrvalue='*' id='option${selectName}' class='defaultOption' data-attrname='' >${selectName}</option>`;
								Object.values(attrValues).map((optVal => {
								if (optVal.name == attrName) {
										optVal.values.map((val => {
											qvTString += `<option data-attrname='${selectName_lc}' data-orig='${selectName}' data-attrlength=${attrLength} data-attrvalue="${val.value}" value="${val.value}">${val.value}</option>`
										}))
									}
								}))
								qvTString += `</select></div>`;
							} else {
								qvTString += `<p id='${selectForId}Input__id0' data-orig='${selectName}' data-attrname='${selectName_lc}' data-twist="one-option" class="one-option qvAttr" data-attrvalue="${optionValue}" class="selected" disabled>${optionValue}</p></div>`;
							}
						} 
						if (attrDisplayStyle == 'flat') {
							Object.values(attrValues).map((optVal => {
								if (optVal.name == attrName) {
									optionLength = optVal.values.length;
									optionValue = optVal.values[0].value;
								}
							}))
							qvTString += `<div class="form-group form-attr ${selectName_lc}-select-group-flat-qv">`
							qvTString += `<label for="${selectName_lc}Input_id0">${selectName}</label>`
							Object.values(attrValues).map((optVal => {
								if(optVal.name == attrName) {
									optionLength = optVal.values.length;
									optionValue = optVal.values[0].value;
								}
							}))
							if(optionLength === 1) {isSelectedOneOpt='size-selected selected'};
							qvTString += `<ul data-twist='${selectName_lc}-select-0' data-orig='${selectName}' id='${selectForId}Input__id0' title='Please select valid ${selectName_lc}' class='form-control flat qvAttr' data-validate="required" name="attrValue" data-attrname='${selectName}' data-saledept='' data-salemic='' tabindex='-1'>`
							Object.values(attrValues).map((listItems => {
								if (listItems.name == attrName) {
									listItems.values.map((val => {
										qvTString += `<li data-attrname='${selectName_lc}'data-orig='${selectName}' data-attrlength=${attrLength} data-attrvalue="${val.value}" value="${val.value}" class='${isSelectedOneOpt}'>${val.value}</li>`;
									}))
								}
							}))
							qvTString += `</ul></div>`
						}
						if (parsedJSON.additionalSizes && selectName_lc === 'size') {
							var additionalSizes = parsedJSON.additionalSizes.filter((currentSize) => currentSize.productURL !== '') || [];
							if (additionalSizes.length > 0) {
								qvTString += `<div id='addtlSizesContainer'><span>Also Available In:</span>`;
								for (var x = 0; x < additionalSizes.length; x++) {
									var additionalSize = additionalSizes[x];
									qvTString += `<a data-toggle="modal" data-modal-body='callQuickView({"catentryId":"${additionalSize.productId}","categoryId": "addtlSize"})' data-target=".modal-quickview" data-modal-title="${additionalSize.productName}" data-novalidation class='additionalSizeLink'>${additionalSize.additionalName}</a>`;
								}
								qvTString += `</div>`;
							}
						}
						// build swatches for desktop quickviews
						let showSelected = '';
						Object.values(attrValues).map((optVal => {
							if(optVal.name == 'Color') {
								optionLength = optVal.values.length;
								if(optionLength === 1) {
									showSelected = 'swatch-selected'; 
								} else {
									showSelected = '';
								}
							}
						}))
						
						//build swatches
						let swatchArr = [];
						let colorForSwatch, fullImage, swatchImg;
						parsedJSON.skus.map((sku => {
							fullImage = sku.fullImage;
							swatchImg = sku.thumbnail;
							sku.definingAttributes.map((dAttr => {
								if(dAttr.name === 'Color') {
									colorForSwatch = dAttr.value.value;
									let swatchArrCheck = JSON.stringify(swatchArr);
									if(!swatchArrCheck.includes(colorForSwatch)) {
										swatchArr.push({ colorForSwatch, fullImage, swatchImg });
									}
								}
							}))											
						}))
						if (selectName_lc === 'color' && swatchArr.length > 0  && $('.desktopPage').length > 0) {
							qvTString += `<div id="static-quickViewSwatches"><div class="swatchGroups"><ul class="swatchList">`;
							swatchArr.map((swatch => {
								let strippedColorForSelector = swatch.colorForSwatch.replace(/[^a-z0-9]/gi, '');
								qvTString += `<li class="swatchListItem" data-selector="${strippedColorForSelector.split(' ').join('')}">
								<span class="swatchSpan" data-spancolor="${swatch.colorForSwatch.split('#double;').join('&quot;')}"></span>
								<button type="button" class="btn-tertiary p-0 swatchButton" aria-current="false">
								<img class="swatchImage ${showSelected}" src="//dimg.dillards.com/is/image/DillardsZoom/${swatch.swatchImg}" 
												data-colorname="${swatch.colorForSwatch.split('#double;').join('&quot;')}" 
												data-selector="${strippedColorForSelector.split(' ').join('')}" 
												alt="color-${swatch.colorForSwatch.split('#double;').join('&quot;')}">
										<span class='sr-only'>- selecting a color swatch will update the main product image</span>
										</button>`
								qvTString += `</li>`

							}))
						qvTString += `</ul></div></div >`;
					}
					}))

					if (!(parsedJSON.preOrder && parsedJSON.preOrder.previewEndDateMessage)) {
						qvTString += `<div class="input-group form-group quantity-select required">
					                    <label for="quantityInput" class="qtyLabel">Quantity</label>
					                    <div class="quantityInputWrapper"><span class="stepperQtyMinus" role="button" aria-label="Subtract 1 item" tabindex="0">-</span><input data-twist="qty-input" id="quantityInput" name="quantity" type="tel" data-mask="0#" autocomplete="off" maxlength="2" class="qtyInput form-control" value="1" data-toggle="tooltip" data-placement="top" title="Number between 1 and 99" data-validate="maxValue(99),minValue(1)"><span class="stepperQtyPlus" role="button" aria-label="Add 1 item" tabindex="0">+</span></div>
									  </div>`;
					}
					qvTString += `</form></div>`;
				}
				qvTString += `</div></section>`;
				try{
					const categoryIdToTrackAs = window?.personalizationCategoryIds?.split('|')?.find(catgroupIdToTrackAs => {
						return parsedJSON?.personalization?.catgroupIdNames?.find(catgroupIdName => {
							const productCatgroupId = catgroupIdName.split('|')[0].split('301_')[1];
							return productCatgroupId === catgroupIdToTrackAs;
						});
					});
					if(categoryIdToTrackAs){
						qvTString += `<div class="hidden personalizationsuperforpoints">${categoryIdToTrackAs}</div>`
					}
				}catch(e) { }
				if(parsedJSON.personalization.otherSuperCatIds && parsedJSON.personalization.otherSuperCatIds == '430'){
					qvTString += `<div class="hidden personalizationothersuper">${parsedJSON.personalization.otherSuperCatIds}</div>`
				}
				qvTString += `<div class="hidden personalizationsuper">${parsedJSON.personalization.superCatId}</div>
							  <div class="hidden personalizationsuperName">${parsedJSON.personalization.catGroups[0]}</div>
							  <div class="hidden personalizationbrand">${parsedJSON.personalization.brandName}</div>
							  <div class="hidden personalizationdeptmic">${parsedJSON.personalization.deptMic}</div>
							  <script async="true" src="//static.criteo.net/js/ld/ld.js" type="text/javascript"></script>
							  <span id="d_eId" style="display:none"></span>
							  <script src="//cdn.cquotient.com/js/v2/gretel.min.js" type="text/javascript"></script>`;

				var qvTString_end = `</div><div class="panel-footer quickViewActions" id="quickViewFooter">`;
				if (notRegistry && !(parsedJSON.preOrder && parsedJSON.preOrder.previewEndDateMessage)) {
					qvTString_end += `<div class="shopper-actions text-right"><a aria-role="button" data-twist="add-to-bag" tabindex="0" class="btn btn-primary prevent-double-click-hack-for-ibm-cookie-problem" data-toggle="modal" data-target=".modal-add-to-bag" data-modal-title="Added to your shopping bag." id="add-to-bag" data-modal-body='ajaxAddToBag({"formId":"OrderItemAdd_qv", "catentry": ${catEntryId}})'>${paramJSON.orderItemIdEdit ? 'Update' : 'Add To Bag'
						}</a>`;
					if (notWishlist && !paramJSON.orderItemIdEdit && !paramJSON.regRec)
						qvTString_end += `<div class="qv_ATW"><a aria-role="button" data-twist="add-to-wishlist" class="btn btn-secondary hide-when-international oneClickOnly" id="add-to-wishlist" tabindex="0" onclick='Dillards.ajaxAddToWishlist({"formId":"OrderItemAdd_qv"})'><i class="icon-heart"></i><span>Add To Wish List</span></a></div>`;
					//removing add-to-registry button
					if (notRegistry && !paramJSON.orderItemIdEdit && !paramJSON.regRec)
						qvTString_end += `<div class="qv_ATW"><a data-twist="add-to-registry" class="btn btn-secondary hide-when-international oneClickOnly userRegistered" data-toggle="modal" data-target=".modal-add-to-registry" data-modal-title="Added to your Registry." id="add-to-registry" tabindex="0" data-modal-body='ajaxAddToRegistry({"formId":"OrderItemAdd_qv", "catentry": ${catEntryId}})'><i class="icon-present"></i><span>Add To Registry</span></a></div>`;
					if (paramJSON.regRec)
						qvTString_end += `<a data-twist="add-to-registry" class="btn btn-secondary hide-when-international userRegistered" data-toggle="modal" data-target=".modal-add-to-registry" data-modal-title="Added to your Registry." id="add-to-registry" tabindex="0" data-modal-body='ajaxAddToRegistry({"formId":"OrderItemAdd_qv"})'>Add To Registry</a>`;
					qvTString_end += `</div>`;
				}
				qvTString_end += `</div ></div ></div ></div ></div > <div class="modal-backdrop fade in"></div>`;
				// Build Complete Your Look
				if (paramJSON.OSS) {
					var accessoryList = '';
					_.forEach($('#this-look-carousel img'), function (element, key) {
						var cylSelected = '';
						let catentry_id = $(element).data('catentryid'),
							accessoryImg = $(element).prop('src').split('/nav/').join('/productItem/'),
							accessoryImgSplit = accessoryImg.split('/'),
							cylAccessoryImgName = accessoryImgSplit[accessoryImgSplit.length - 1].split('.jpg').join('').split('_')[0],
							cylMainImgName = mainImgName.split('/')[mainImgName.split('/').length - 1].split('.jpg').join('').split('_')[0],
							modalTitle = $(element).parent().data('modal-title'),
							productKeyword = modalTitle.replace(/\s+/g, '-').split('"').join('').split('&').join('').split('?').join('').toLowerCase();
						if (cylAccessoryImgName === cylMainImgName) cylSelected = 'cylSelected';
						accessoryList += `< img class="accessory ${cylSelected}" id = "accessory_${key}" src = "${accessoryImg}" data - qv="oss" data - catentryid="${catentry_id}" data - title="${modalTitle}" /> `;
					});
					accessoryList += `</div > `;
					if ($('.desktopPage').length > 0)
						cylDesktop(
							paramJSON,
							parsedJSON.personalization.trackingJSON,
							accessoryList,
							'COMPLETE YOUR LOOK',
							altImgTString,
							mainImgTString,
							modalTitle,
							pricingTString,
							productID,
							productURL,
							qvTString,
							qvTString_end,
							personalizationBrand,
							urlFormattedBrandName
						);
					else if ($('.tabletPage').length > 0)
						cylTablet(
							paramJSON,
							parsedJSON.personalization.trackingJSON,
							accessoryList,
							'COMPLETE YOUR LOOK',
							altImgTString,
							mainImgTString,
							modalTitle,
							pricingTString,
							productID,
							productURL,
							qvTString,
							qvTString_end,
							personalizationBrand,
							urlFormattedBrandName
						);
					else
						Modernizr.mq('(min-width: 768px)')
							? cylSuperMobile(
									paramJSON,
									parsedJSON.personalization.trackingJSON,
									accessoryList,
									'COMPLETE YOUR LOOK',
									altImgTString,
									mainImgTString,
									modalTitle,
									pricingTString,
									productID,
									productURL,
									qvTString,
									qvTString_end,
									personalizationBrand,
									urlFormattedBrandName
							  )
							: cylMobile(
									paramJSON,
									parsedJSON.personalization.trackingJSON,
									accessoryList,
									'COMPLETE YOUR LOOK',
									altImgTString,
									mainImgTString,
									modalTitle,
									pricingTString,
									productID,
									productURL,
									qvTString,
									qvTString_end,
									personalizationBrand,
									urlFormattedBrandName
							  );
				} else if (paramJSON.collection) {
					var collectionList = '';
					_.forEach($('#' + paramJSON.collectionArea + ' .collection-list img'), function (element, key) {
						var cylSelected = '';
						let catentry_id = $(element).data('catentryid'),
							accessoryColor = $(element).data('color'),
							accessoryImg = $(element).prop('src').split('/productRec/').join('/productItem/'),
							modalTitle = $(element).parent().data('modal-title').split('"').join('&quot'),
							productKeyword = modalTitle.replace(/\s+/g, '-').split('"').join('').split('&').join('').split('?').join('').toLowerCase();
						if (paramJSON.catentryId == catentry_id && (paramJSON.color == '' || paramJSON.color.toLowerCase() == accessoryColor.toLowerCase()))
							cylSelected = 'cylSelected';
						collectionList += `< img class="accessory ${cylSelected}" id = "accessory_${key}" src = "${accessoryImg}" data - qv="collection" data - catentryid="${catentry_id}" data - title="${modalTitle}" data - collectionarea="${paramJSON.collectionArea}" data - color="${accessoryColor}" /> `;
					});
					collectionList += `</div > `;
					if ($('.desktopPage').length > 0)
						cylDesktop(
							paramJSON,
							parsedJSON.personalization.trackingJSON,
							collectionList,
							'SHOP THE COLLECTION',
							altImgTString,
							mainImgTString,
							modalTitle,
							pricingTString,
							productID,
							productURL,
							qvTString,
							qvTString_end,
							personalizationBrand,
							urlFormattedBrandName
						);
					else if ($('.tabletPage').length > 0)
						cylTablet(
							paramJSON,
							parsedJSON.personalization.trackingJSON,
							collectionList,
							'SHOP THE COLLECTION',
							altImgTString,
							mainImgTString,
							modalTitle,
							pricingTString,
							productID,
							productURL,
							qvTString,
							qvTString_end,
							personalizationBrand,
							urlFormattedBrandName
						);
					else
						Modernizr.mq('(min-width: 768px)')
							? cylSuperMobile(
									paramJSON,
									parsedJSON.personalization.trackingJSON,
									collectionList,
									'SHOP THE COLLECTION',
									altImgTString,
									mainImgTString,
									modalTitle,
									pricingTString,
									productID,
									productURL,
									qvTString,
									qvTString_end,
									personalizationBrand,
									urlFormattedBrandName
							  )
							: cylMobile(
									paramJSON,
									parsedJSON.personalization.trackingJSON,
									collectionList,
									'SHOP THE COLLECTION',
									altImgTString,
									mainImgTString,
									modalTitle,
									pricingTString,
									productID,
									productURL,
									qvTString,
									qvTString_end,
									personalizationBrand,
									urlFormattedBrandName
							  );
				} else {
					if ($('.mobilePage').length > 0)
						Modernizr.mq('(min-width: 768px)')
							? qvSuperMobile(
									paramJSON,
									parsedJSON.personalization.trackingJSON,
									altImgTString,
									mainImgTString,
									modalTitle,
									pricingTString,
									productID,
									productURL,
									qvTString,
									qvTString_end,
									personalizationBrand,
									urlFormattedBrandName
							  )
							: qvMobile(
									paramJSON,
									parsedJSON.personalization.trackingJSON,
									altImgTString,
									mainImgTString,
									modalTitle,
									pricingTString,
									productID,
									productURL,
									qvTString,
									qvTString_end,
									personalizationBrand,
									urlFormattedBrandName
							  );
					else if ($('.tabletPage').length > 0)
						qvTablet(
							paramJSON,
							parsedJSON.personalization.trackingJSON,
							altImgTString,
							mainImgTString,
							modalTitle,
							pricingTString,
							productID,
							productURL,
							qvTString,
							qvTString_end,
							personalizationBrand,
							urlFormattedBrandName
						);
					else
						qvDesktop(
							paramJSON,
							parsedJSON.personalization.trackingJSON,
							altImgTString,
							mainImgTString,
							modalTitle,
							pricingTString,
							productID,
							productURL,
							qvTString,
							qvTString_end,
							personalizationBrand,
							urlFormattedBrandName
						);
				}
			} else {
				var mainImgTString, mainImgName;
				if (parsedJSON.fullImage !== undefined) {
					mainImgName = freshenUp(parsedJSON.fullImage.imageName);
					mainImgTString = `<img data-twist="main-image" id='mainImg' class="mainImage" src = "${mainImgName}" alt = "${freshenUp(
						parsedJSON.fullImage.altText
					)} " style="visibility: visible; ">`;
				} else {
					mainImgTString = `<img data-twist="main-image" id='mainImg' class="mainImage" src="//dimg.dillards.com/is/image/DillardsZoom/nav/error/missing-full-img.jpg" alt="Image not available" style="visibility: visible;">`;
				}
				// Split Brand from Modal Title
				var newTitle = '';
				try {
					newTitle = json.personalization.trackingJSON.product.name;
					if (newTitle != '') modalTitle = newTitle.split('#double;').join('"');
				} catch (e) { }
				let personalizationBrand = parsedJSON.personalization.brandName,
					urlFormattedBrandName = parsedJSON.personalization.urlFormattedBrandName,
					thisBrand1 = `${personalizationBrand} `,
					thisBrand2 = `${personalizationBrand}®`,
					splitText = modalTitle.toLowerCase().split('&').join('&'),
					brandWithSpace = splitText.indexOf(thisBrand1.toLowerCase()) == 0,
					brandWithR = splitText.indexOf(thisBrand2.toLowerCase()) == 0,
					brandPartOfName = brandWithSpace || brandWithR;
				if (brandPartOfName) {
					let realBrand = brandWithSpace ? thisBrand1 : thisBrand2,
						subStringIndex = realBrand.split('&').join('&').length;
					personalizationBrand = modalTitle.substring(0, subStringIndex);
					modalTitle = modalTitle.substring(subStringIndex);
				}
				qv_notAvailable(parsedJSON, {}, '', mainImgTString, modalTitle, urlFormattedBrandName, personalizationBrand);
			}

			let getDivSKUS;
			let isItem, isInitial, isOneSize = false;
			let attrLength;
			//for registry quick view modals that don't have skus
			if(document.getElementById('allSkus')) {
				getDivSKUS = JSON.parse(document.getElementById('allSkus').innerText);
				let hasOneOption = document.getElementsByClassName('one-option');
				let oneOptAttr;
				if(hasOneOption.length > 0) {
					hasOneOption.forEach((item => {oneOptAttr = item.getAttribute('data-orig')}));
				}
				
				//check for items, initials, if length is 1 or a oneSize attr
				Object.values(getDivSKUS).forEach((sku => {
					attrLength = sku.definingAttributes.length;
					sku.definingAttributes.forEach((val => {
						if(val.name === 'Item') {
							isItem = true;
						}
						if(val.name === 'Initial') {
							isInitial = true;
						}
						if(val.name === 'Size' && val.value.value === 'One Size') {
							isOneSize = true;
						}
					}))
				}))
				
				if(attrLength === 1 || isItem || isOneSize)  {
					oneAttrPageLoad();
				}
				if(isItem && hasOneOption.optionLength === 0) {
					itemPageLoad();
				}
				if(hasOneOption.length > 0 && !isItem)  {
					oneOptPageLoad(oneOptAttr);
				}
				if(hasOneOption.length > 0 && isItem)  {
					oneOptPageLoad(oneOptAttr, isItem);
				}
			}	
			//Attribute Listeners DROPDOWNS////
			$('select.qvAttr').on("change", (event) => {
				let attrName = event.target.getAttribute('data-orig');
				let attrLength = parseInt(event.target.getAttribute('data-attrlength'));
				let selectedVal = event.target.value;
				let getOneOption = document.getElementsByClassName('one-option');
				let hasOneOption;
				if(getOneOption.length > 0) {
					hasOneOption = true;
				}
				if(attrLength === 1 || isOneSize) {
					dropDownOneAttrChange(attrName, selectedVal);
				} else {
					if(isItem) {
						dropDownAttrChange(attrName, selectedVal, 'item', hasOneOption);  
					} else {
						dropDownAttrChange(attrName, selectedVal, 'notItem', hasOneOption);  
					}
				}
				try {
					if (typeof zonos === 'object') {
						zonos.displayCurrency();
					}
				} catch (e) {
					console.log(e);
				}
			});

			//FLAT BUTTONS//
			$('ul.qvAttr li').on("click", (event) => { 
				let attrName = event.target.getAttribute('data-orig');
				let selectedVal = event.target.innerHTML;
				let attrLength = parseInt(event.target.getAttribute('data-attrlength'));
				let hasOneOption = false;
				let getOneOption = document.getElementsByClassName('one-option');
				if(getOneOption.length > 0) {
					hasOneOption = true;
				}
				if(attrLength === 1) {
					buttonOneAttrChange(attrName, selectedVal)
				} else {
					buttonAttrChange(attrName, selectedVal, hasOneOption);  
				}
				try {
					if (typeof zonos === 'object') {
						zonos.displayCurrency();
					}
				} catch (e) {
					console.log(e);
				}
			});

			if ($('#static-quickViewSwatches .swatchImage').length > 1) {
				$('#static-quickViewSwatches .swatchImage').on('click', function (event) {
					let getSwatchColor = event.target.dataset.colorname;
					if(attrLength === 1 || isOneSize) {
						dropDownOneAttrChange('Color', getSwatchColor);
					} else {
						dropDownAttrChange('Color', getSwatchColor);
					}
				});
			}

			$('.modal .alt-image-list-container ul li img').on('click', function (e) {
				let isRegistry = $('#layoutRegistry').length > 0;
				if (!isRegistry) {
					altClickImages(e);
				}
			})
			
			$('.swatchList').slick({
				dots: false,
				arrows: true,
				autoplay: false,
				draggable: false,
				swipe: true,
				infinite: false,
				vertical: false,
				speed: 500,
				slidesToShow: 6,
				slidesToScroll: 1,
				lazyLoad: 'ondemand',
			});
		},
	});
};

export { buildQV, freshenUp };
